export const LMS_ENTRY_CONTROLLERS = [
  "resource_course",
  "resource_course_new",
  "resource_parent_child",
  "resource_wonder_wall",
  "resource_resource_hub",
  "resource_folder",
  "resource_staff",
  "resource_role_group",
];

const hasRole = (roleList, type, ctrl) =>
  Array.isArray(roleList) &&
  roleList.some(
    (role) =>
      role &&
      role.type === type &&
      role.module === "resource" &&
      role.ctrl === ctrl &&
      role.action === "get_list",
  );

export const hasLmsAccess = (merchantContext) => {
  if (
    !merchantContext ||
    !Array.isArray(merchantContext.role_list) ||
    !merchantContext.me ||
    !Array.isArray(merchantContext.me.role_list)
  ) {
    return false;
  }

  return LMS_ENTRY_CONTROLLERS.some(
    (ctrl) =>
      hasRole(merchantContext.role_list, "MERCHANT", ctrl) &&
      hasRole(merchantContext.me.role_list, "STAFF", ctrl),
  );
};
